// @ts-ignore-next-line
import React from"react";import styles from"./P.module.scss";export var P=function P(_ref){var children=_ref.children;return/*#__PURE__*/React.createElement("p",{className:styles.p},children);};